import type { TablePaginationConfig } from 'antd';

/**
 * 列表页统一分页配置：默认每页 10 条，可切换 10/20/50/100/200。
 * 用 defaultPageSize（非受控）而非 pageSize（受控），否则「条/页」选择器选了不生效。
 */
export const LIST_PAGINATION: TablePaginationConfig = {
  defaultPageSize: 10,
  showSizeChanger: true,
  pageSizeOptions: [10, 20, 50, 100, 200],
};

/**
 * 列表页表格的纵向滚动高度：随视窗自适应，行多时表格体内部滚动、表头固定，避免整页滑动。
 * 320px 预留给顶栏 + 页面标题 + 操作/筛选区 + 表头 + 底部分页。
 */
export const LIST_SCROLL_Y = 'calc(100vh - 320px)';
